import { IListClientsResponse } from "../../../model/sdp/base/list-clients-response";
import { IAuthenticationRequest } from "../../../model/security/request/authentication-request";
import { IPreAuthenticationRequest } from "../../../model/security/request/pre-authentication-request";
import { IAuthenticationResponse } from "../../../model/security/response/authentication-response";
import { IPreAuthenticationResponse } from "../../../model/security/response/pre-authentication-response";
import { IUserAuthenticatedResponse } from "../../../model/security/response/user-authenticated-response";
import HttpClient from "../../services/http-client";
import ApplicationAppService from "../application-app-service";

const defaultPath = 'Authentication';

let applicationData = ApplicationAppService.getApplicationData();

const preAuthentication = async (params: IPreAuthenticationRequest): Promise<IPreAuthenticationResponse> => {

    return await HttpClient.executeRequest({
        method: 'post',
        data: params,
        baseURL: applicationData.baseUrlAuthentication,
        url: `/${defaultPath}/PreAuthentication`
    }).then((response) => Object.assign({} as IPreAuthenticationResponse, response.data));
};

const authentication = async (params: IAuthenticationRequest): Promise<IAuthenticationResponse> => {
    return await HttpClient.executeRequest({
        method: 'post',
        data: params,
        baseURL: applicationData.baseUrlAuthentication,
        url: `/${defaultPath}/Authentication`
    })
        .then((response) =>
            Object.assign({} as IAuthenticationResponse, response.data)
        )
};

const isAuthenticated = async (): Promise<IUserAuthenticatedResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: applicationData.baseUrlAuthentication,
        url: `/${defaultPath}/IsAuthenticated`
    })
        .then((response) =>
            Object.assign({} as IUserAuthenticatedResponse, response.data)
        )
};

const listClients = async (clientId: number | undefined): Promise<IListClientsResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/Base/clients`,
        baseURL: applicationData.baseUrlAuthentication,
        params: {clientId}
    }).then((response) => Object.assign([] as unknown as IListClientsResponse, response.data));
};

const logout = async (): Promise<void> => {
    const authData = ApplicationAppService.getAuthenticationData();
    if (!authData) return;

    await HttpClient.executeRequest({
        method: 'post',
        baseURL: applicationData.baseUrlAuthentication,
        url: `/${defaultPath}/Logout`,
        data: {
            bearerToken: authData.bearerToken,
            userId: authData.user.id
        }
    });
};


const AuthenticatorAppService = {
    preAuthentication, authentication, isAuthenticated, listClients, logout
};

export default AuthenticatorAppService;